import type { ReactNode } from "react";
import { ErrorState, Panel } from "@akaike/ui";
import type { Platform } from "../api/generated/model";
import { platformFromKey } from "../api/platforms";

// A route whose :platform is not in the API's closed set. The API answers 422 to such a
// key, so the page shows this instead of firing a request that cannot succeed.
export function UnknownPlatform({ platform }: { platform: string }) {
  return (
    <Panel>
      <Panel.Body>
        <ErrorState
          compact
          title="Unknown platform"
          message={
            <>
              <span className="mono">{platform}</span> is not a platform this app tracks.
            </>
          }
        />
      </Panel.Body>
    </Panel>
  );
}

/** Narrows a route's :platform param for the page below it. Hooks cannot run
 * conditionally, so the page body is an inner component that takes the narrowed key. */
export function WithRoutePlatform({
  platform,
  children,
}: {
  platform: string;
  children: (key: Platform) => ReactNode;
}) {
  const key = platformFromKey(platform);
  return key === undefined ? <UnknownPlatform platform={platform} /> : children(key);
}
